import { useNavigate } from "react-router-dom";
import { Row, Col, Modal, Form, Input, Button, App } from "antd";
import { resetPassword } from "./api";
import { clearExcept } from "@/utils/tools";
import "./index.less";
export default function Index(props) {
  const { message } = App.useApp();
  const { closePassModal } = props;
  const [form] = Form.useForm();
  const navigate = useNavigate();

  async function changePassWord(val) {
    const { data: { code }, } = await resetPassword(val);
    if (+code === 0) {
      closePassModal();
      message.success("密码修改成功,请重新登录", 0.5, () => {
        clearExcept();
        navigate("/login", { replace: true });
      });
    }
  }
  const handleCancel = () => {
    closePassModal();
  };
  const onFinish = (val) => {
    changePassWord(val);
  };

  return (
    <Modal title='重置密码' open onCancel={handleCancel} footer={null} width={613} right >
      <div style={{ marginTop: 46 }}></div>
      <Form style={{ width: 552 }} name="change_password" labelCol={{ span: 4 }} wrapperCol={{ span: 24 }} onFinish={onFinish} autoComplete="off" form={form} >
        <Form.Item label={"旧密码"} name="password" rules={[{ required: true, message: "请输入旧密码" }]} >
          <Input.Password visibilityToggle={true} maxLength={30} placeholder={"请输入新密码"} />
        </Form.Item>
        <Form.Item label={"新密码"} name="new_password" rules={[{ required: true, message: '' }, () => ({
          validator(_, value) {
            if (value) {
              if (value?.length < 6) {
                return Promise.reject(new Error('请输入至少6个字符，请不要使用容易被猜到的密码'));
              } else {
                if (!/[a-zA-Z]/.test(value)) {
                  return Promise.reject(new Error("密码强度太弱,请至少输入一个英文字母,请不要使用容易被猜到的密码"));
                }
                if (!/[0-9]/.test(value)) {
                  return Promise.reject(new Error("密码强度太弱,请至少输入一个阿拉伯数字,请不要使用容易被猜到的密码"));
                }
                return Promise.resolve();
              }
            } else {
              return Promise.reject(new Error('请输入新密码'));
            }
          },
        }),
        ]}
        >
          <Input.Password maxLength={16} visibilityToggle={true} placeholder={"6-16位密码，必须有数字和英文字母"} />
        </Form.Item>
        <Form.Item label={"确认密码"} name="re_new_password" required rules={[{ required: true, message: "请确认密码!" }, ({ getFieldValue }) => ({
          validator(_, value) {
            if (!value || getFieldValue("new_password") === value) {
              return Promise.resolve();
            }
            return Promise.reject("两次密码输入不一致");
          },
        }),
        ]}
        >
          <Input.Password visibilityToggle={true} maxLength={16} placeholder={"确认密码"} />
        </Form.Item>
        <Form.Item>
          <Row><Col offset={8} span={8}><Button block type="primary" htmlType="submit">保存</Button></Col></Row>
        </Form.Item>
      </Form>
    </Modal>
  );
};
